import { render } from "./PageIsland.vue?vue&type=template&id=18edc694"
import script from "./PageIsland.vue?vue&type=script&lang=js"
export * from "./PageIsland.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__